/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export const NotificationCenterEventClass = {
    FAILED: "FAILED",
    WARNING: "WARNING",
    SUCCESS: "SUCCESS",
    NEUTRAL: "NEUTRAL",
};
export const NotificationCenterEventParameterType = {
    Integer: "Integer",
    Float: "Float",
    Boolean: "Boolean",
    String: "String",
    Datetime: "Datetime",
    Uuid: "Uuid",
};
import axios from "axios";
import qs from "qs";
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = async ({ secure, path, type, query, format, body, ...params }) => {
            const secureParams = ((typeof secure === "boolean" ? secure : this.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = format || this.format || undefined;
            if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
                body = this.createFormData(body);
            }
            if (type === ContentType.UrlEncoded && body && body !== null && typeof body === "object") {
                body = qs.stringify(body);
            }
            if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
                body = JSON.stringify(body);
            }
            return this.instance.request({
                ...requestParams,
                headers: {
                    ...(requestParams.headers || {}),
                    ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
                },
                params: query,
                responseType: responseFormat,
                data: body,
                url: path,
            });
        };
        this.instance = axios.create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL || "",
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "indices" }),
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method && this.instance.defaults.headers[method.toLowerCase()]) || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
}
/**
 * @title RVAI Notification Center Service
 * @version 0.1.0
 */
export class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.eventTypes = {
            /**
             * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags event_types
             * @name ListEventTypes
             * @summary List Event Types
             * @request GET:/event-types
             * @secure
             */
            listEventTypes: (query, params = {}) => this.request({
                path: `/event-types`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags event_types
             * @name RegisterEventType
             * @summary Register Event Type
             * @request POST:/event-types
             * @secure
             */
            registerEventType: (data, params = {}) => this.request({
                path: `/event-types`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags event_types
             * @name ListEventTypeFields
             * @summary List Event Type Fields
             * @request GET:/event-types/fields
             * @secure
             */
            listEventTypeFields: (params = {}) => this.request({
                path: `/event-types/fields`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags event_types
             * @name DeregisterEventType
             * @summary Deregister Event Type
             * @request DELETE:/event-types/{event_type_id}/{event_type_version}
             * @secure
             */
            deregisterEventType: (eventTypeId, eventTypeVersion, params = {}) => this.request({
                path: `/event-types/${eventTypeId}/${eventTypeVersion}`,
                method: "DELETE",
                secure: true,
                ...params,
            }),
        };
        this.events = {
            /**
             * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags events
             * @name TriggerEvent
             * @summary Trigger Event
             * @request POST:/events
             * @secure
             */
            triggerEvent: (data, params = {}) => this.request({
                path: `/events`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),
        };
        this.livez = {
            /**
             * @description Get application heartbeat.
             *
             * @tags monitor
             * @name GetHeartbeat
             * @summary Get Heartbeat
             * @request GET:/livez
             * @secure
             */
            getHeartbeat: (params = {}) => this.request({
                path: `/livez`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.notifications = {
            /**
             * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags notifications
             * @name DeleteNotifications
             * @summary Delete Notifications
             * @request DELETE:/notifications
             * @secure
             */
            deleteNotifications: (query, params = {}) => this.request({
                path: `/notifications`,
                method: "DELETE",
                query: query,
                secure: true,
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags notifications
             * @name ListNotifications
             * @summary List Notifications
             * @request GET:/notifications
             * @secure
             */
            listNotifications: (query, params = {}) => this.request({
                path: `/notifications`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags notifications
             * @name DeleteAllNotifications
             * @summary Delete All Notifications
             * @request DELETE:/notifications/all
             * @secure
             */
            deleteAllNotifications: (params = {}) => this.request({
                path: `/notifications/all`,
                method: "DELETE",
                secure: true,
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags notifications
             * @name MarkAllNotificationsAsRead
             * @summary Mark All Notifications As Read
             * @request POST:/notifications/all/read
             * @secure
             */
            markAllNotificationsAsRead: (params = {}) => this.request({
                path: `/notifications/all/read`,
                method: "POST",
                secure: true,
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags notifications
             * @name ListNotificationFields
             * @summary List Notification Fields
             * @request GET:/notifications/fields
             * @secure
             */
            listNotificationFields: (params = {}) => this.request({
                path: `/notifications/fields`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags notifications
             * @name MarkNotificationsAsRead
             * @summary Mark Notifications As Read
             * @request POST:/notifications/read
             * @secure
             */
            markNotificationsAsRead: (query, params = {}) => this.request({
                path: `/notifications/read`,
                method: "POST",
                query: query,
                secure: true,
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags notifications
             * @name GetNotificationUpdates
             * @summary Get Notification Updates
             * @request GET:/notifications/updates
             * @secure
             */
            getNotificationUpdates: (params = {}) => this.request({
                path: `/notifications/updates`,
                method: "GET",
                secure: true,
                ...params,
            }),
        };
        this.prometheus = {
            /**
             * No description
             *
             * @tags monitor
             * @name GetPrometheusMetrics
             * @summary Get Prometheus Metrics
             * @request GET:/prometheus
             * @secure
             */
            getPrometheusMetrics: (params = {}) => this.request({
                path: `/prometheus`,
                method: "GET",
                secure: true,
                ...params,
            }),
        };
        this.version = {
            /**
             * @description Get application version.
             *
             * @tags monitor
             * @name GetVersion
             * @summary Get Version
             * @request GET:/version
             * @secure
             */
            getVersion: (params = {}) => this.request({
                path: `/version`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
    }
}
//# sourceMappingURL=data:application/json;base64,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